export enum VendorTableColumnKeys {
    NAME = "name",
    CREDITOR_NUMBER = "creditorNumber",
    ORDERS = "orders",
    RECOMMENDATION = "recommendation",
    EXPENSES = "expenses",
}

export enum EmployeeVendorTableColumnKeys {
    NAME = "name",
    CREDITOR_NUMBER = "creditorNumber",
    EXPENSES = "expenses",
}
